import { createFileRoute, notFound } from "@tanstack/react-router";
import { DeCitySlugRoute } from "@/pages/CitySlugRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/$deCitySlug/")({
  beforeLoad: ({ params }) => {
    if (!params.deCitySlug?.startsWith("gebrauchtwagen-")) throw notFound();
  },
  head: ({ params }) => routeHead("/de/$deCitySlug/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DeCitySlugRoute />
  );
}
